import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Cell } from 'fixed-data-table-2'
import classnames from 'classnames/bind'
import { formatters } from '../../../utils'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const renderValue = (value, { truthyVal, falsyVal }) => {
  return formatters.formatBool(value, truthyVal, falsyVal)
}

const BoolCell = props => {
  const { rowIndex, definition, data, ...restProps } = props
  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]

  return (
    <Cell
      data-elm-id={`${baseField}_${rowIndex}_cell`}
      className={cx('cell')}
      {...restProps}
    >
      <div
        data-elm-id={`${baseField}_${rowIndex}_value`}
        style={{ width: DataTableUtils.getCellInnerWidth(definition.colProps) }}
        className={cx('text-truncate')}
      >
        {renderValue(
          _.get(row, field) || row[baseField],
          definition.formatOptions || {}
        )}
      </div>
    </Cell>
  )
}

/**
 * formatOptions for BoolCell allow for custom defined truthy and falsy values to show when pre-formatted
 * value is true and false, respectively.
 * e.g. formatOptions: {
 *  truthyVal: 'Yes',
 *  falsyVal: 'No',
 * }
 */

BoolCell.propTypes = {
  rowIndex: PropTypes.number,
  definition: PropTypes.shape({
    colProps: PropTypes.object.isRequired,
    field: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    formatOptions: PropTypes.shape({
      truthyVal: PropTypes.string,
      falsyVal: PropTypes.string,
    }),
  }).isRequired,
  data: PropTypes.array,
}

export default BoolCell
